export const featuredProject = {
  title: "DocOps",
  tagline: "Documentation engineered.",
  description:
    "A documentation engineering application that demonstrates how documentation can be built, operated, validated, and maintained as an engineered system. DocOps brings together docs-as-code, governance, API documentation, OpenAPI, automated documentation health, CI/CD, and AI-ready documentation practices.",
  technologies: [
    "Next.js",
    "React",
    "TypeScript",
    "MDX",
    "SCSS",
    "OpenAPI",
    "GitHub Actions",
  ],
  image: "./docops.png",
  liveUrl: "https://docops-gamma.vercel.app",
  sourceUrl: "https://github.com/hollyabrams/docops",
};

export const projects = [
  {
    title: "Mode - Ecommerce",
    subtitle: "React, Node.js, Stripe API",
    description:
      "Mode is an online shopping platform where users can browse products, manage their shopping carts, and make purchases.",
    image: "./mode.gif",
    link: "https://mode-ecommerce.onrender.com/",
  },
  {
    title: "Disney Characterverse",
    subtitle: "Python, Flask, SQLAlchemy",
    description:
      "Disney Characterverse is a web application that allows users to explore, learn about, and save their favorite Disney characters.",
    image: "./disney-characterverse.gif",
    link: "https://disney-characterverse.onrender.com/",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "Documentation Engineering",
  "Developer Documentation",
  "API Documentation",
  "SDK Documentation",
  "Docs-as-Code",
  "Developer Experience",
  "Information Architecture",
  "Technical Writing",
  "OpenAPI",
  "React",
  "Next.js",
  "TypeScript",
  "MDX",
  "JavaScript",
  "Python",
  "Git & GitHub",
  "CI/CD",
  "Documentation Automation",
  "Postman",
  "Content Management",
  "Knowledge Management",
];

export const experiences = [
  { title: 'Senior Documentation Engineer', 
    company: 'EasyPost', 
    duration: 'December 2023 - September 2026', 
    description: 'Owned and evolved developer documentation for an API-first SaaS platform, combining technical writing with documentation engineering and developer experience. Maintained a docs-as-code platform built with Next.js, React, MDX, and Git; documented REST APIs, carrier integrations, and complex shipping workflows; and partnered closely with Engineering, Product, and UX. Improved documentation architecture, search, release workflows, and automation while developing scalable standards and tooling for public and internal documentation.', },
  { title: 'Software Engineering Fellow', 
    company: 'Springboard', 
    duration: 'March 2022 - June 2023', 
    description: 'Completed 800+ hours of intensive, project-based software engineering training with 1:1 mentorship from an industry professional. Built full-stack applications while developing practical experience with JavaScript, React, Node.js, Python, databases, APIs, testing, data structures, and algorithms.', },
  { title: 'Knowledge Manager', 
    company: 'Brasfield & Gorrie', 
    duration: 'August 2019 - December 2021', 
    description: 'Led enterprise knowledge management initiatives, including the implementation and front-end development of a company-wide intranet. Established governance, information architecture, content standards, and publishing processes to create a scalable, user-friendly knowledge ecosystem while partnering across teams to improve information access and employee experience.', },
  { title: 'Content Manager', 
    company: 'Brasfield & Gorrie', 
    duration: 'January 2016 - August 2019', 
    description: 'Managed content operations and functional administration for the company intranet across multiple content management systems. Developed publishing workflows, administered access controls, improved content architecture, and partnered with stakeholders across the organization to continuously improve the platform and the employee content experience.', },
];



// WEBPACK FOOTER //
// ./src/data.js